import { render, staticRenderFns } from "./AccountHolderBeneficiaries.vue?vue&type=template&id=3b1dd46b&scoped=true"
import script from "./AccountHolderBeneficiaries.vue?vue&type=script&lang=ts"
export * from "./AccountHolderBeneficiaries.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderBeneficiaries.vue?vue&type=style&index=0&id=3b1dd46b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1dd46b",
  null
  
)

export default component.exports